import AgentPreferences from 'models/agent_preferences';

// localStorage cache for AgentPreferences. The backend is the source of truth,
// but we mirror writes to localStorage so a page reload renders with the agent's
// last-known prefs immediately instead of flashing the defaults until the
// backend fetch comes back. The key is unchanged from before the split so
// existing users' data carries over on first boot.
export const AGENT_PREFERENCES_CACHE_KEY = 'gladly-agent-preferences';

export function readAgentPreferencesCache() {
  try {
    const raw = localStorage.getItem(AGENT_PREFERENCES_CACHE_KEY);
    return AgentPreferences.fromJs((raw && JSON.parse(raw)) || {});
  } catch (e) {
    return new AgentPreferences();
  }
}

export function writeAgentPreferencesCache(preferences) {
  try {
    localStorage.setItem(AGENT_PREFERENCES_CACHE_KEY, JSON.stringify(preferences.toJs()));
  } catch (e) {
    // localStorage may be unavailable / full; the backend write is authoritative.
  }
}
